<div class="typewriter-container">
	<p>{{ displayedText }}</p>
</div>
